module.exports = __webpack_public_path__ + "static/media/logo-expo-medica.777b45d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-expo-medica.png
// module id = 43
// module chunks = 0